import {useMemo, useRef} from "react";

import {IPromptInternalProps, IPromptProps} from "../types/IPromptProps";

export const usePreventContextDefaultOnClose = (_intervalContext: IPromptProps & IPromptInternalProps) => {
    const ref = useRef(_intervalContext);

    return useMemo(() => {
        if (_intervalContext.isPromptOpen) {
            ref.current = _intervalContext;
        }

        return ref.current;
    }, [_intervalContext]);
};
import {useMemo, useRef} from "react";

import {IPromptInternalProps, IPromptProps} from "../types/IPromptProps";

export const usePreventContextDefaultOnClose = (_intervalContext: IPromptProps & IPromptInternalProps) => {
    const ref = useRef(_intervalContext);

    return useMemo(() => {
        if (_intervalContext.isPromptOpen) {
            ref.current = _intervalContext;
        }

        return ref.current;
    }, [_intervalContext]);
};
